import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../../lib/react-query";
import { RootState } from "../../../../redux/store";
import { useQuery } from "@tanstack/react-query";
import { getExtraFieldPagination } from "../api/extraFieldApi";

type QueryFnType = typeof getExtraFieldPagination;

type UseSearchExtraFieldPaginationOptions = {
    config?: QueryConfig<QueryFnType>;
    showEmpties: boolean;
};

export const useExtraFieldPagination = ({ config, showEmpties }: UseSearchExtraFieldPaginationOptions) => {
  	const extraFieldPagination = useSelector((state: RootState) => state.historical.extraFields);

  	return useQuery<ExtractFnReturnType<QueryFnType>>({
		...config,
		refetchOnMount: false,
		refetchOnWindowFocus: false,
		retry: false,
		queryKey: ['ExtraFieldPagination', showEmpties, extraFieldPagination.currentPage, extraFieldPagination.itemsPerPage, extraFieldPagination.searchText],
		queryFn: () => getExtraFieldPagination(
			{ 
				pageNumber: extraFieldPagination.currentPage, 
				pageSize: extraFieldPagination.itemsPerPage,
				showEmpties: showEmpties,
				search: extraFieldPagination.searchText
			}),
  	});
}
